import { DataSource } from '@angular/cdk/collections';

export abstract class SpxAbstractDataSource<T> extends DataSource<T> {}
